"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.EventType = void 0;
/**
 * Duplicated types from editor-platform-sdk-types/src/events/EventType.ts
 * to allow use them in public packages
 */
var EventType;
(function (EventType) {
    EventType["removeAppCompleted"] = "removeAppCompleted";
    EventType["componentSelectionChanged"] = "componentSelectionChanged";
    EventType["appInstalled"] = "appInstalled";
    EventType["appUpdateCompleted"] = "appUpdateCompleted";
})(EventType || (exports.EventType = EventType = {}));
